// ref: ng g m shared

// TIP: Shared module will be imported by many lazy loaded features and because of that 
// it should NEVER implement any services (providers: [ ]) and only contain 
// declarables (components, directives and pipes) and modules (which only contain declarables).
// The reason for that is that every lazy loaded module would get its own service instance 
// which is almost never what we want because in most cases we expect services to be global singletons!
// 
// If we want create “shared” services used in many parts of our application we should implement 
// them in the /core folder and use providedIn: 'root' syntax without putting them 
// in 'providers: []' of any module…

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from "@angular/material/menu";
import { LayoutModule } from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

/*
import { NgModule } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";

@NgModule({
    exports: [
        MatMenuModule
    ]

})

export class StackblitzMaterialModule {}
*/

@NgModule({
  declarations: [],
  imports: [
    // vendor
    CommonModule,       // ngIf, ngFor 
    RouterModule,       // routerLink, <router-outlet>

    LayoutModule,

    // material
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,

    // forms
    FormsModule
  ],
  exports: [
    CommonModule,
    RouterModule,

    LayoutModule,

    // material
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,

    // forms
    FormsModule

  ]
})
export class SharedModule {}
